// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".input-label[data-v-4003b4f2] {\n  margin-right: 4px;\n}\n.toggle-all-button[data-v-4003b4f2] {\n  margin-top: 7px;\n  text-decoration: underline;\n  color: #4e5a6a;\n}\n.toggle-all-button[data-v-4003b4f2]:hover {\n  color: #000;\n}\n", ""]);
// Exports
module.exports = exports;
